/* src/app/features/taxas-juros/taxa-juros-equivalente/taxa-juros-equivalente-listagem.component.scss */
.icone-adicionar {
  padding-left: 12px;
  padding-bottom: 12px;
}
/*# sourceMappingURL=taxa-juros-equivalente-listagem.component.css.map */
